import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { N500 } from '@atlaskit/theme/colors';
import { messages } from '../../messages';
import { fontCharlieText } from '../styled';

export const SocialSignUpDivider = () => {
  return (
    <SocialSignUpDividerLabel>
      <FormattedMessage {...messages.socialSignUpDividerLabel} />
    </SocialSignUpDividerLabel>
  );
};

const SocialSignUpDividerLabel = styled.div`
  font-family: ${fontCharlieText};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 24px;
  margin-top: 24px;
`;
